import { useEffect } from "react";
import { getSEO } from "../services/seoService";

const useSEO = (page) => {
    useEffect(() => {
        const loadSEO = async () => {
            const seo = await getSEO(page);

            if (seo && !seo.error) {
                document.title = seo.title;

                document
                    .querySelector("meta[name='description']")
                    ?.setAttribute("content", seo.description);

                document
                    .querySelector("meta[name='keywords']")
                    ?.setAttribute("content", seo.keywords);
            }
        };

        loadSEO();
    }, [page]);
};

export default useSEO;